export {default as VmAcademicCapIcon} from './VmAcademicCapIcon'
export {default as VmAdjustmentsHorizontalIcon} from './VmAdjustmentsHorizontalIcon'
export {default as VmAdjustmentsVerticalIcon} from './VmAdjustmentsVerticalIcon'
export {default as VmArchiveBoxArrowDownIcon} from './VmArchiveBoxArrowDownIcon'
export {default as VmArchiveBoxIcon} from './VmArchiveBoxIcon'
export {default as VmArchiveBoxXMarkIcon} from './VmArchiveBoxXMarkIcon'
export {default as VmArrowDownCircleIcon} from './VmArrowDownCircleIcon'
export {default as VmArrowDownIcon} from './VmArrowDownIcon'
export {default as VmArrowDownLeftIcon} from './VmArrowDownLeftIcon'
export {default as VmArrowDownOnSquareIcon} from './VmArrowDownOnSquareIcon'
export {default as VmArrowDownOnSquareStackIcon} from './VmArrowDownOnSquareStackIcon'
export {default as VmArrowDownRightIcon} from './VmArrowDownRightIcon'
export {default as VmArrowDownTrayIcon} from './VmArrowDownTrayIcon'
export {default as VmArrowLeftCircleIcon} from './VmArrowLeftCircleIcon'
export {default as VmArrowLeftIcon} from './VmArrowLeftIcon'
export {default as VmArrowLeftOnRectangleIcon} from './VmArrowLeftOnRectangleIcon'
export {default as VmArrowLongDownIcon} from './VmArrowLongDownIcon'
export {default as VmArrowLongLeftIcon} from './VmArrowLongLeftIcon'
export {default as VmArrowLongRightIcon} from './VmArrowLongRightIcon'
export {default as VmArrowLongUpIcon} from './VmArrowLongUpIcon'
export {default as VmArrowPathIcon} from './VmArrowPathIcon'
export {default as VmArrowPathRoundedSquareIcon} from './VmArrowPathRoundedSquareIcon'
export {default as VmArrowRightCircleIcon} from './VmArrowRightCircleIcon'
export {default as VmArrowRightIcon} from './VmArrowRightIcon'
export {default as VmArrowRightOnRectangleIcon} from './VmArrowRightOnRectangleIcon'
export {default as VmArrowSmallDownIcon} from './VmArrowSmallDownIcon'
export {default as VmArrowSmallLeftIcon} from './VmArrowSmallLeftIcon'
export {default as VmArrowSmallRightIcon} from './VmArrowSmallRightIcon'
export {default as VmArrowSmallUpIcon} from './VmArrowSmallUpIcon'
export {default as VmArrowsPointingInIcon} from './VmArrowsPointingInIcon'
export {default as VmArrowsPointingOutIcon} from './VmArrowsPointingOutIcon'
export {default as VmArrowsRightLeftIcon} from './VmArrowsRightLeftIcon'
export {default as VmArrowsUpDownIcon} from './VmArrowsUpDownIcon'
export {default as VmArrowTopRightOnSquareIcon} from './VmArrowTopRightOnSquareIcon'
export {default as VmArrowTrendingDownIcon} from './VmArrowTrendingDownIcon'
export {default as VmArrowTrendingUpIcon} from './VmArrowTrendingUpIcon'
export {default as VmArrowUpCircleIcon} from './VmArrowUpCircleIcon'
export {default as VmArrowUpIcon} from './VmArrowUpIcon'
export {default as VmArrowUpLeftIcon} from './VmArrowUpLeftIcon'
export {default as VmArrowUpOnSquareIcon} from './VmArrowUpOnSquareIcon'
export {default as VmArrowUpOnSquareStackIcon} from './VmArrowUpOnSquareStackIcon'
export {default as VmArrowUpRightIcon} from './VmArrowUpRightIcon'
export {default as VmArrowUpTrayIcon} from './VmArrowUpTrayIcon'
export {default as VmArrowUturnDownIcon} from './VmArrowUturnDownIcon'
export {default as VmArrowUturnLeftIcon} from './VmArrowUturnLeftIcon'
export {default as VmArrowUturnRightIcon} from './VmArrowUturnRightIcon'
export {default as VmArrowUturnUpIcon} from './VmArrowUturnUpIcon'
export {default as VmArticleIcon} from './VmArticleIcon'
export {default as VmAtSymbolIcon} from './VmAtSymbolIcon'
export {default as VmBackspaceIcon} from './VmBackspaceIcon'
export {default as VmBackwardIcon} from './VmBackwardIcon'
export {default as VmBanknotesIcon} from './VmBanknotesIcon'
export {default as VmBars2Icon} from './VmBars2Icon'
export {default as VmBars3BottomLeftIcon} from './VmBars3BottomLeftIcon'
export {default as VmBars3BottomRightIcon} from './VmBars3BottomRightIcon'
export {default as VmBars3CenterLeftIcon} from './VmBars3CenterLeftIcon'
export {default as VmBars3Icon} from './VmBars3Icon'
export {default as VmBars4Icon} from './VmBars4Icon'
export {default as VmBarsArrowDownIcon} from './VmBarsArrowDownIcon'
export {default as VmBarsArrowUpIcon} from './VmBarsArrowUpIcon'
export {default as VmBattery0Icon} from './VmBattery0Icon'
export {default as VmBattery50Icon} from './VmBattery50Icon'
export {default as VmBattery100Icon} from './VmBattery100Icon'
export {default as VmBeakerIcon} from './VmBeakerIcon'
export {default as VmBellAlertIcon} from './VmBellAlertIcon'
export {default as VmBellIcon} from './VmBellIcon'
export {default as VmBellSlashIcon} from './VmBellSlashIcon'
export {default as VmBellSnoozeIcon} from './VmBellSnoozeIcon'
export {default as VmBoltIcon} from './VmBoltIcon'
export {default as VmBoltSlashIcon} from './VmBoltSlashIcon'
export {default as VmBookmarkIcon} from './VmBookmarkIcon'
export {default as VmBookmarkSlashIcon} from './VmBookmarkSlashIcon'
export {default as VmBookmarkSquareIcon} from './VmBookmarkSquareIcon'
export {default as VmBookOpenIcon} from './VmBookOpenIcon'
export {default as VmBriefcaseIcon} from './VmBriefcaseIcon'
export {default as VmBugAntIcon} from './VmBugAntIcon'
export {default as VmBuildingLibraryIcon} from './VmBuildingLibraryIcon'
export {default as VmBuildingOffice2Icon} from './VmBuildingOffice2Icon'
export {default as VmBuildingOfficeIcon} from './VmBuildingOfficeIcon'
export {default as VmBuildingStorefrontIcon} from './VmBuildingStorefrontIcon'
export {default as VmCakeIcon} from './VmCakeIcon'
export {default as VmCalculatorIcon} from './VmCalculatorIcon'
export {default as VmCalendarDaysIcon} from './VmCalendarDaysIcon'
export {default as VmCalendarIcon} from './VmCalendarIcon'
export {default as VmCameraIcon} from './VmCameraIcon'
export {default as VmCartIcon} from './VmCartIcon'
export {default as VmCashIcon} from './VmCashIcon'
export {default as VmChartBarFloatingIcon} from './VmChartBarFloatingIcon'
export {default as VmChartBarIcon} from './VmChartBarIcon'
export {default as VmChartBarSquareIcon} from './VmChartBarSquareIcon'
export {default as VmChartLineUpIcon} from './VmChartLineUpIcon'
export {default as VmChartPieIcon} from './VmChartPieIcon'
export {default as VmChatBubbleBottomCenterIcon} from './VmChatBubbleBottomCenterIcon'
export {default as VmChatBubbleBottomCenterTextIcon} from './VmChatBubbleBottomCenterTextIcon'
export {default as VmChatBubbleLeftEllipsisIcon} from './VmChatBubbleLeftEllipsisIcon'
export {default as VmChatBubbleLeftIcon} from './VmChatBubbleLeftIcon'
export {default as VmChatBubbleLeftRightIcon} from './VmChatBubbleLeftRightIcon'
export {default as VmChatBubbleOvalLeftEllipsisIcon} from './VmChatBubbleOvalLeftEllipsisIcon'
export {default as VmChatBubbleOvalLeftIcon} from './VmChatBubbleOvalLeftIcon'
export {default as VmCheckBadgeIcon} from './VmCheckBadgeIcon'
export {default as VmCheckCircleIcon} from './VmCheckCircleIcon'
export {default as VmCheckIcon} from './VmCheckIcon'
export {default as VmChevronDoubleDownIcon} from './VmChevronDoubleDownIcon'
export {default as VmChevronDoubleLeftIcon} from './VmChevronDoubleLeftIcon'
export {default as VmChevronDoubleRightIcon} from './VmChevronDoubleRightIcon'
export {default as VmChevronDoubleUpIcon} from './VmChevronDoubleUpIcon'
export {default as VmChevronDownIcon} from './VmChevronDownIcon'
export {default as VmChevronLeftIcon} from './VmChevronLeftIcon'
export {default as VmChevronRightIcon} from './VmChevronRightIcon'
export {default as VmChevronUpDownIcon} from './VmChevronUpDownIcon'
export {default as VmChevronUpIcon} from './VmChevronUpIcon'
export {default as VmCircleStackIcon} from './VmCircleStackIcon'
export {default as VmClipboardDocumentCheckIcon} from './VmClipboardDocumentCheckIcon'
export {default as VmClipboardDocumentIcon} from './VmClipboardDocumentIcon'
export {default as VmClipboardDocumentListIcon} from './VmClipboardDocumentListIcon'
export {default as VmClipboardIcon} from './VmClipboardIcon'
export {default as VmClockIcon} from './VmClockIcon'
export {default as VmCloudArrowDownIcon} from './VmCloudArrowDownIcon'
export {default as VmCloudArrowUpIcon} from './VmCloudArrowUpIcon'
export {default as VmCloudIcon} from './VmCloudIcon'
export {default as VmCodeBracketIcon} from './VmCodeBracketIcon'
export {default as VmCodeBracketSquareIcon} from './VmCodeBracketSquareIcon'
export {default as VmCog6ToothIcon} from './VmCog6ToothIcon'
export {default as VmCog8ToothIcon} from './VmCog8ToothIcon'
export {default as VmCogIcon} from './VmCogIcon'
export {default as VmCommandLineIcon} from './VmCommandLineIcon'
export {default as VmComputerDesktopIcon} from './VmComputerDesktopIcon'
export {default as VmCpuChipIcon} from './VmCpuChipIcon'
export {default as VmCreditCardIcon} from './VmCreditCardIcon'
export {default as VmCubeIcon} from './VmCubeIcon'
export {default as VmCubeTransparentIcon} from './VmCubeTransparentIcon'
export {default as VmCurrencyBangladeshiIcon} from './VmCurrencyBangladeshiIcon'
export {default as VmCurrencyDollarIcon} from './VmCurrencyDollarIcon'
export {default as VmCurrencyEuroIcon} from './VmCurrencyEuroIcon'
export {default as VmCurrencyPoundIcon} from './VmCurrencyPoundIcon'
export {default as VmCurrencyRupeeIcon} from './VmCurrencyRupeeIcon'
export {default as VmCurrencyYenIcon} from './VmCurrencyYenIcon'
export {default as VmCurrentLocationIcon} from './VmCurrentLocationIcon'
export {default as VmCursorArrowRaysIcon} from './VmCursorArrowRaysIcon'
export {default as VmCursorArrowRippleIcon} from './VmCursorArrowRippleIcon'
export {default as VmDeleteBinIcon} from './VmDeleteBinIcon'
export {default as VmDevicePhoneMobileIcon} from './VmDevicePhoneMobileIcon'
export {default as VmDeviceTabletIcon} from './VmDeviceTabletIcon'
export {default as VmDiscountIcon} from './VmDiscountIcon'
export {default as VmDocumentArrowDownIcon} from './VmDocumentArrowDownIcon'
export {default as VmDocumentArrowUpIcon} from './VmDocumentArrowUpIcon'
export {default as VmDocumentChartBarIcon} from './VmDocumentChartBarIcon'
export {default as VmDocumentCheckIcon} from './VmDocumentCheckIcon'
export {default as VmDocumentDuplicateIcon} from './VmDocumentDuplicateIcon'
export {default as VmDocumentIcon} from './VmDocumentIcon'
export {default as VmDocumentMagnifyingGlassIcon} from './VmDocumentMagnifyingGlassIcon'
export {default as VmDocumentMinusIcon} from './VmDocumentMinusIcon'
export {default as VmDocumentPlusIcon} from './VmDocumentPlusIcon'
export {default as VmDocumentTextIcon} from './VmDocumentTextIcon'
export {default as VmDrugsIcon} from './VmDrugsIcon'
export {default as VmEllipsisHorizontalCircleIcon} from './VmEllipsisHorizontalCircleIcon'
export {default as VmEllipsisHorizontalIcon} from './VmEllipsisHorizontalIcon'
export {default as VmEllipsisVerticalIcon} from './VmEllipsisVerticalIcon'
export {default as VmEnvelopeIcon} from './VmEnvelopeIcon'
export {default as VmEnvelopeOpenIcon} from './VmEnvelopeOpenIcon'
export {default as VmExcelIcon} from './VmExcelIcon'
export {default as VmExclamationCircleIcon} from './VmExclamationCircleIcon'
export {default as VmExclamationTriangleIcon} from './VmExclamationTriangleIcon'
export {default as VmEyeDropperIcon} from './VmEyeDropperIcon'
export {default as VmEyeIcon} from './VmEyeIcon'
export {default as VmEyeSlashIcon} from './VmEyeSlashIcon'
export {default as VmFaceFrownIcon} from './VmFaceFrownIcon'
export {default as VmFaceSmileIcon} from './VmFaceSmileIcon'
export {default as VmFilmIcon} from './VmFilmIcon'
export {default as VmFingerPrintIcon} from './VmFingerPrintIcon'
export {default as VmFireIcon} from './VmFireIcon'
export {default as VmFlagIcon} from './VmFlagIcon'
export {default as VmFolderArrowDownIcon} from './VmFolderArrowDownIcon'
export {default as VmFolderIcon} from './VmFolderIcon'
export {default as VmFolderMinusIcon} from './VmFolderMinusIcon'
export {default as VmFolderOpenIcon} from './VmFolderOpenIcon'
export {default as VmFolderPlusIcon} from './VmFolderPlusIcon'
export {default as VmForwardIcon} from './VmForwardIcon'
export {default as VmFunnelIcon} from './VmFunnelIcon'
export {default as VmGifIcon} from './VmGifIcon'
export {default as VmGiftIcon} from './VmGiftIcon'
export {default as VmGiftTopIcon} from './VmGiftTopIcon'
export {default as VmGlobeAltIcon} from './VmGlobeAltIcon'
export {default as VmGlobeAmericasIcon} from './VmGlobeAmericasIcon'
export {default as VmGlobeAsiaAustraliaIcon} from './VmGlobeAsiaAustraliaIcon'
export {default as VmGlobeEuropeAfricaIcon} from './VmGlobeEuropeAfricaIcon'
export {default as VmHandRaisedIcon} from './VmHandRaisedIcon'
export {default as VmHandThumbDownIcon} from './VmHandThumbDownIcon'
export {default as VmHandThumbUpIcon} from './VmHandThumbUpIcon'
export {default as VmHashtagIcon} from './VmHashtagIcon'
export {default as VmHeartIcon} from './VmHeartIcon'
export {default as VmHomeIcon} from './VmHomeIcon'
export {default as VmHomeModernIcon} from './VmHomeModernIcon'
export {default as VmHomePlusIcon} from './VmHomePlusIcon'
export {default as VmIdentificationIcon} from './VmIdentificationIcon'
export {default as VmImagePlusIcon} from './VmImagePlusIcon'
export {default as VmInboxArrowDownIcon} from './VmInboxArrowDownIcon'
export {default as VmInboxIcon} from './VmInboxIcon'
export {default as VmInboxStackIcon} from './VmInboxStackIcon'
export {default as VmInformationCircleIcon} from './VmInformationCircleIcon'
export {default as VmKeyIcon} from './VmKeyIcon'
export {default as VmLanguageIcon} from './VmLanguageIcon'
export {default as VmLifebuoyIcon} from './VmLifebuoyIcon'
export {default as VmLightBulbIcon} from './VmLightBulbIcon'
export {default as VmLinkIcon} from './VmLinkIcon'
export {default as VmListBulletIcon} from './VmListBulletIcon'
export {default as VmListNumbersBoldIcon} from './VmListNumbersBoldIcon'
export {default as VmListPencilIcon} from './VmListPencilIcon'
export {default as VmLockClosedIcon} from './VmLockClosedIcon'
export {default as VmLockOpenIcon} from './VmLockOpenIcon'
export {default as VmMagnifyingGlassCircleIcon} from './VmMagnifyingGlassCircleIcon'
export {default as VmMagnifyingGlassIcon} from './VmMagnifyingGlassIcon'
export {default as VmMagnifyingGlassMinusIcon} from './VmMagnifyingGlassMinusIcon'
export {default as VmMagnifyingGlassPlusIcon} from './VmMagnifyingGlassPlusIcon'
export {default as VmMapIcon} from './VmMapIcon'
export {default as VmMapPinIcon} from './VmMapPinIcon'
export {default as VmMarkerGroupIcon} from './VmMarkerGroupIcon'
export {default as VmMegaphoneIcon} from './VmMegaphoneIcon'
export {default as VmMicrophoneIcon} from './VmMicrophoneIcon'
export {default as VmMinusCircleIcon} from './VmMinusCircleIcon'
export {default as VmMinusIcon} from './VmMinusIcon'
export {default as VmMinusSmallIcon} from './VmMinusSmallIcon'
export {default as VmMoneyIcon} from './VmMoneyIcon'
export {default as VmMoonIcon} from './VmMoonIcon'
export {default as VmMusicalNoteIcon} from './VmMusicalNoteIcon'
export {default as VmNewspaperIcon} from './VmNewspaperIcon'
export {default as VmNoSymbolIcon} from './VmNoSymbolIcon'
export {default as VmPaintBrushIcon} from './VmPaintBrushIcon'
export {default as VmPaperAirplaneIcon} from './VmPaperAirplaneIcon'
export {default as VmPaperClipIcon} from './VmPaperClipIcon'
export {default as VmPauseCircleIcon} from './VmPauseCircleIcon'
export {default as VmPauseIcon} from './VmPauseIcon'
export {default as VmPencilIcon} from './VmPencilIcon'
export {default as VmPencilSquareIcon} from './VmPencilSquareIcon'
export {default as VmPhoneArrowDownLeftIcon} from './VmPhoneArrowDownLeftIcon'
export {default as VmPhoneArrowUpRightIcon} from './VmPhoneArrowUpRightIcon'
export {default as VmPhoneIcon} from './VmPhoneIcon'
export {default as VmPhoneXMarkIcon} from './VmPhoneXMarkIcon'
export {default as VmPhotoIcon} from './VmPhotoIcon'
export {default as VmPlayCircleIcon} from './VmPlayCircleIcon'
export {default as VmPlayIcon} from './VmPlayIcon'
export {default as VmPlayPauseIcon} from './VmPlayPauseIcon'
export {default as VmPlusCircleIcon} from './VmPlusCircleIcon'
export {default as VmPlusIcon} from './VmPlusIcon'
export {default as VmPlusSmallIcon} from './VmPlusSmallIcon'
export {default as VmPowerIcon} from './VmPowerIcon'
export {default as VmPresentationChartBarIcon} from './VmPresentationChartBarIcon'
export {default as VmPresentationChartLineIcon} from './VmPresentationChartLineIcon'
export {default as VmPrinterIcon} from './VmPrinterIcon'
export {default as VmPuzzlePieceIcon} from './VmPuzzlePieceIcon'
export {default as VmQrCodeIcon} from './VmQrCodeIcon'
export {default as VmQuestionMarkCircleIcon} from './VmQuestionMarkCircleIcon'
export {default as VmQueueListIcon} from './VmQueueListIcon'
export {default as VmRadioIcon} from './VmRadioIcon'
export {default as VmReceiptPercentIcon} from './VmReceiptPercentIcon'
export {default as VmReceiptRefundIcon} from './VmReceiptRefundIcon'
export {default as VmRectangleGroupIcon} from './VmRectangleGroupIcon'
export {default as VmRectangleStackIcon} from './VmRectangleStackIcon'
export {default as VmRocketLaunchIcon} from './VmRocketLaunchIcon'
export {default as VmRssIcon} from './VmRssIcon'
export {default as VmScaleIcon} from './VmScaleIcon'
export {default as VmScissorsIcon} from './VmScissorsIcon'
export {default as VmServerIcon} from './VmServerIcon'
export {default as VmServerStackIcon} from './VmServerStackIcon'
export {default as VmShareIcon} from './VmShareIcon'
export {default as VmShieldCheckIcon} from './VmShieldCheckIcon'
export {default as VmShieldExclamationIcon} from './VmShieldExclamationIcon'
export {default as VmShoppingBagIcon} from './VmShoppingBagIcon'
export {default as VmShoppingCartIcon} from './VmShoppingCartIcon'
export {default as VmSignalIcon} from './VmSignalIcon'
export {default as VmSignalSlashIcon} from './VmSignalSlashIcon'
export {default as VmSparklesIcon} from './VmSparklesIcon'
export {default as VmSpeakerWaveIcon} from './VmSpeakerWaveIcon'
export {default as VmSpeakerXMarkIcon} from './VmSpeakerXMarkIcon'
export {default as VmSquare2StackIcon} from './VmSquare2StackIcon'
export {default as VmSquare3Stack3DIcon} from './VmSquare3Stack3DIcon'
export {default as VmSquares2X2Icon} from './VmSquares2X2Icon'
export {default as VmSquaresPlusIcon} from './VmSquaresPlusIcon'
export {default as VmStarIcon} from './VmStarIcon'
export {default as VmStopCircleIcon} from './VmStopCircleIcon'
export {default as VmStopIcon} from './VmStopIcon'
export {default as VmSunIcon} from './VmSunIcon'
export {default as VmSwatchIcon} from './VmSwatchIcon'
export {default as VmTableCellsIcon} from './VmTableCellsIcon'
export {default as VmTagIcon} from './VmTagIcon'
export {default as VmTicketIcon} from './VmTicketIcon'
export {default as VmTrashIcon} from './VmTrashIcon'
export {default as VmTrophyIcon} from './VmTrophyIcon'
export {default as VmTruckIcon} from './VmTruckIcon'
export {default as VmTvIcon} from './VmTvIcon'
export {default as VmUserArrowLeftIcon} from './VmUserArrowLeftIcon'
export {default as VmUserArrowRightIcon} from './VmUserArrowRightIcon'
export {default as VmUserCircleIcon} from './VmUserCircleIcon'
export {default as VmUserGroupIcon} from './VmUserGroupIcon'
export {default as VmUserIcon} from './VmUserIcon'
export {default as VmUserKeyIcon} from './VmUserKeyIcon'
export {default as VmUserMinusIcon} from './VmUserMinusIcon'
export {default as VmUserPlusIcon} from './VmUserPlusIcon'
export {default as VmUsersAvatarComIcon} from './VmUsersAvatarComIcon'
export {default as VmUsersIcon} from './VmUsersIcon'
export {default as VmUserStarIcon} from './VmUserStarIcon'
export {default as VmVariableIcon} from './VmVariableIcon'
export {default as VmVideoCameraIcon} from './VmVideoCameraIcon'
export {default as VmVideoCameraSlashIcon} from './VmVideoCameraSlashIcon'
export {default as VmViewColumnsIcon} from './VmViewColumnsIcon'
export {default as VmViewfinderCircleIcon} from './VmViewfinderCircleIcon'
export {default as VmWalletIcon} from './VmWalletIcon'
export {default as VmWhatsappIcon} from './VmWhatsappIcon'
export {default as VmWifiIcon} from './VmWifiIcon'
export {default as VmWindowIcon} from './VmWindowIcon'
export {default as VmWrenchIcon} from './VmWrenchIcon'
export {default as VmWrenchScrewdriverIcon} from './VmWrenchScrewdriverIcon'
export {default as VmXCircleIcon} from './VmXCircleIcon'
export {default as VmXMarkIcon} from './VmXMarkIcon'
